import { createContext } from 'react';
import type { PlatformType } from '@alfa-bank/newclick-types';

export type SidePanelManagerContextType = {
    open: boolean;
    platform: PlatformType;
};

export const SidePanelManagerContext = createContext<SidePanelManagerContextType | null>(null);
